import { render, staticRenderFns } from "./TabModalShare.vue?vue&type=template&id=c4945a28&scoped=true&"
import script from "./TabModalShare.vue?vue&type=script&lang=js&"
export * from "./TabModalShare.vue?vue&type=script&lang=js&"
import style0 from "./TabModalShare.vue?vue&type=style&index=0&id=c4945a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4945a28",
  null
  
)

export default component.exports